import getModelStore from "@yiban-shared/store/model";

function isPostRequest() {
  return true; // 默认全部使用 POST 请求
}

async function getModelOptionsByType(
  modelType,
  { model, params, config, $store }
) {
  let result = [];

  if (modelType === "list") {
    // 使用列表接口取配置
    const { list } = await $store.$getModelList(model, params, config);
    result = list;
  }

  return result;
}

export default getModelStore({ getModelOptionsByType, isPostRequest });
